import { ZhihuOutlined } from '@ant-design/icons'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { api, sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunk, RootThunkApi } from '../../app/store'
import { List } from '../../models/page'
import * as S from '../../services/medical'

export interface CountryPageValue {
  acdbas: string
  advaltaxAdjmDrugFlag: string
  advaltaxAdjmDrugName: string
  alis: string
  aprvno: string
  aprvnoBegndate: string
  aprvnoEnddate: string
  basMednFlag: string
  basMednFlagName: string
  begndate: string
  chemname: string
  chldMedc: string
  coName: string
  consevalDrug: string
  convrat: number
  createUser: number
  crteTime: string
  drugDosform: string
  drugDosformName: string
  drugExpy: string
  drugGenname: string
  drugProdname: string
  drugRegAppvletrElecacs: string
  drugRegcertBegndate: string
  drugRegcertEnddate: string
  drugRegno: string
  drugSpec: string
  drugSpecCode: string
  drugType: string
  drugTypeName: string
  drugstdcode: string
  dstr: string
  dstrAuthFileElecacs: string
  dstrConer: string
  eachDos: string
  efccAtd: string
  efftTime: string
  enddate: string
  engName: string
  gennameCodg: string
  hiNegoDrugFlag: string
  hiNegoDrugName: string
  insuranceCode: string
  invdTime: string
  isDeleted: number
  isuFlag: string
  lmtUsedFlag: string
  lmtUsescp: string
  lstdDruglistDrug: string
  lstdLicHolder: string
  manl: string
  medListCodg: string
  memo: string
  minPacCnt: number
  minPacunt: string
  minPrcunt: string
  minPrepunt: string
  minPrepuntName: string
  minSalunt: string
  minUnt: string
  minUseunt: string
  minpacuntName: string
  mktStas: string
  mktStasName: string
  natDrugNo: string
  natHiDruglistChrgitmLv: string
  natHiDruglistDosform: string
  natHiDruglistMemo: string
  nhcDrugCodg: string
  otcFlag: string
  otcFlagName: string
  pacCnt: string
  pacmatl: string
  pacmatlName: string
  pacspec: string
  pinyin: string
  prcuntType: string
  prodentpCode: string
  prodentpName: string
  prodplacType: string
  prodplacTypeName: string
  regDosform: string
  regName: string
  regSpec: string
  regSpecCode: string
  rid: string
  rute: string
  spDrugFlag: string
  spLmtpricDrugFlag: string
  splmAppyAppvletrFile: string
  status: number
  subpckFcty: string
  tcmpatFlag: string
  tenantId: number
  tramDataId: string
  updateUser: number
  updtTime: string
  usedFrqu: string
  usedMtd: string
  valiFlag: string
  ver: string
  verName: string
  wubi: string
}

// 西药目录
export const getCountryPage = createAsyncThunk<
  List<CountryPageValue>,
  S.CountryPageParams,
  RootThunkApi
>('/medical/getCountryPage', async (body, api) => {
  return sendAsync(S.getCountryPage(body), api)
})

export interface ChinesePageValue {
  begndate: string
  cat: string
  cnvlUsed: string
  cpndFlag: string
  createUser: number
  crteTime: string
  ecyType: string
  efccAtd: string
  efftTime: string
  enddate: string
  insuranceCode: string
  invdTime: string
  isDeleted: number
  isuFlag: string
  medListCodg: string
  medPart: string
  mertpm: string
  mlmsCatSouc: string
  mlmsName: string
  natHiPayPol: string
  natfla: string
  provHiPayPol: string
  psdgMtd: string
  qltReg: string
  rid: string
  safeMtr: string
  status: number
  stdElecacs: string
  stdName: string
  stdPagen: string
  tcmherbName: string
  tcmherbYear: number
  tenantId: number
  tramDataId: string
  updateUser: number
  updtTime: string
  valiFlag: string
  ver: string
  verName: string
}

// 中药目录
export const getChineseMedicinePage = createAsyncThunk<
  List<ChinesePageValue>,
  S.ChineseMedicinePageParams,
  RootThunkApi
>('/medical/getChinesePage', async (params, api) => {
  return sendAsync(S.getChineseMedicinePage(params), api)
})

export interface DiagnosisValue {
  begndate: string
  createUser: number
  efftTime: string
  enddate: string
  insuranceCode: string
  invdTime: string
  isDeleted: number
  isuFlag: string
  itemDscr: string
  medListCodg: string
  memo: string
  prcunt: string
  prcuntName: string
  rid: string
  servitemName: string
  servitemType: string
  status: number
  tenantId: number
  tramDataId: string
  trtExctCont: string
  trtItemCont: string
  trtItemDscr: string
  updateUser: number
  valiFlag: string
  ver: string
  verName: string
}

// 诊疗目录
export const getDiagnosisPage = createAsyncThunk<
  List<DiagnosisValue>,
  S.DiagnosisPageParams,
  RootThunkApi
>('/medical/getDiagnosisPage', async (params, api) => {
  return sendAsync(S.getDiagnosisPage(params), api)
})

export interface MaterialsValue {
  aftsalSerins: string
  agntEntp: string
  agntEntpAddr: string
  apbScp: string
  aprvDate: string
  begndate: string
  caseFlag: string
  combName: string
  createUser: number
  dspoUsedFlag: string
  dspoUsedFlagName: string
  efftTime: string
  enddate: string
  hiGenname: string
  hiGennameCode: string
  hiLmtScp: string
  highvalMcsFlag: string
  imptItvtClssFlag: string
  imptItvtClssName: string
  imptMatlHmorgnFlag: string
  insuranceCode: string
  invdTime: string
  isDeleted: number
  isuFlag: string
  lmtUsedFlag: string
  manl: string
  manuAddr: string
  manuNatRegn: string
  matlCode: string
  matlTypeCode: string
  mcsMatl: string
  mcsName: string
  mcsType: string
  medEquMgtType: string
  medEquMgtTypeName: string
  medListCodg: string
  minSalunt: string
  minUseunt: string
  othCertMatl: string
  othCont: string
  pacCnt: string
  pacspec: string
  pacunt: string
  perfStruComp: string
  prodConvrat: string
  prodImg: string
  prodImgNo: string
  prodIstr: string
  prodMol: string
  prodPacmatl: string
  prodQltStd: string
  prodentpCode: string
  prodentpName: string
  prodexpy: string
  prodplacType: string
  prodplacTypeName: string
  prodstrd: string
  regFilElecFile: string
  regFilNo: string
  regFilProdName: string
  regcertExpyBegntime: string
  regcertExpyEndtime: string
  regerAddr: string
  regerName: string
  rid: string
  spec: string
  specCode: string
  specMol: string
  spedFlag: string
  spedName: string
  status: number
  stlzFlag: string
  stlzFlagName: string
  struComp: string
  tenantId: number
  tramDataId: string
  udi: string
  updateUser: number
  valiFlag: string
  ver: string
  verName: string
}

// 材料目录
export const getMedicalPage = createAsyncThunk<
  List<MaterialsValue>,
  S.MedicalPageParams,
  RootThunkApi
>('/medical/getMedicalPage', async (params, api) => {
  return sendAsync(S.getMedicalPage(params), api)
})

export interface LimitPriceValue {
  begndate: string
  crteOptinsNo: string
  crteTime: string
  crterId: string
  crterName: string
  enddate: string
  hilistCode: string
  hilistLmtpricType: string
  hilistPricUplmtAmt: number
  insuAdmdvs: string
  insuranceCode: string
  itemType: number
  optTime: string
  opterId: string
  opterName: string
  optinsNo: string
  overlmtDspoWay: string
  poolareaNo: string
  rid: string
  status: number
  tabname: string
  tenantId: number
  updtTime: string
  valiFlag: string
}

// 限价目录
export const getLimitPage = createAsyncThunk<
  List<LimitPriceValue>,
  S.LimitPageParams,
  RootThunkApi
>('/medical/getLimitPage', async (params, api) => {
  return sendAsync(S.getLimitPage(params), api)
})


// 目录上传
export const uploadExcelAsync = createAsyncThunk<
  void,
  S.uploadExcelParams,
  RootThunkApi
>("/commodity/uploadExcelAsync", async (body, api) => {
  return sendAsync(S.uploadExcel(body), api);
});

// 目录同步
export const syncInsuranceListAsync = createAsyncThunk<
  void,
  S.syncInsuranceListParams,
  RootThunkApi
>('/commodity/syncInsuranceListAsync', async (body, api) => {
  return sendAsync(S.syncInsuranceList(body), api)
})

export interface UploadProgressResponse {
  id: number
  updateUser: number
  taskStatus: number
  taskSum: number
  taskCnt: number
  status: number
  createUser: number
  taskMsg: string
  taskName: string
  tenantId: string
  createTime: string
  updateTime: string
}
// 上传进度
export const getUploadProgress = createAsyncThunk<
  void,
  { ids: Array<number> },
  RootThunkApi
>('/commodity/getUploadProgress', async (body, api) => {
  return sendAsync(S.uploadProgress(body), api)
})

// 目录停用导入
export const getZjCatalogChangeImportAsync = createAsyncThunk<
  void,
  S.ZjCatalogChangeImportParams,
  RootThunkApi
>('/commodity/getZjCatalogChangeImportAsync', async (body, api) => {
  return sendAsync(S.getZjCatalogChangeImport(body), api)
})

// 目录变更导入
export const getZjCatalogFullImportAsync = createAsyncThunk<
  void,
  S.ZjCatalogChangeImportParams,
  RootThunkApi
>('/commodity/getZjCatalogFullImportAsync', async (body, api) => {
  return sendAsync(S.getZjCatalogFullImport(body), api)
})

// 目录变更导入
export const getSendCatalogChangeNotifyAsync = createAsyncThunk<
  void,
  S.SendCatalogChangeNotifyParams,
  RootThunkApi
>('/commodity/getSendCatalogChangeNotifyAsync', async (body, api) => {
  return sendAsync(S.getSendCatalogChangeNotify(body), api)
})
